enum ActionTypes {
  FETCH_BUSINESS_FAILURE = 'gofre/business/FETCH_BUSINESS_FAILURE',
  FETCH_BUSINESS_REQUEST = 'gofre/business/FETCH_BUSINESS_REQUEST',
  FETCH_BUSINESS_SUCCESS = 'gofre/business/FETCH_BUSINESS_SUCCESS',
  UPDATE_BUSINESS_VAT_NUMBER = 'gofre/business/UPDATE_BUSINESS_VAT_NUMBER',
}

export default ActionTypes;
